import React from "react";
import { object, number, array } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import { getSlug } from "../../utils";

import CardImageType8 from "../../molecules/card-image-type-8";
import ReadMore from "../../atoms/read-more";
import Headline from "../../atoms/headline";

import "./organism-3.m.css";

const Organism3 = ({ collection, limit = 2, sections }) => {
  const collectionStories = collection.items ? collection.items : [];
  const filteredStories = collectionStories.filter(item => item.type === "story");
  const slug = getSlug(collection, sections);

  return (
    <div styleName="wrapper" className="bg-wrapper">
      <div styleName="header-tabs">
        <Link href={slug}>
          <Headline text={collection.name} headerType={5} headerLevel={3} />
        </Link>
      </div>
      {filteredStories
        .slice(0, limit)
        .map((story, index) => story && <CardImageType8 story={story.story} key={index} />)}
      <ReadMore href={slug} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(Organism3);

Organism3.propTypes = {
  collection: object,
  limit: number,
  sections: array
};
